import React from "react";
import { observer, inject } from "mobx-react";
import GroupSelector from "./_common/group-selector";
import DateSelector from "./_common/date-selector";
import * as M from "@material-ui/core";

const SurveyResultsFilter = props => {
  const { $user, $group, $survey, $respondent } = props.store;

  return (
    <div className="mt-4 flex justify-between">
      {$user.sessionUser.isVerifiedMentor && $group.list.size && (
        <GroupSelector className="mx2 col-6" label="Groep/school" responses />
      )}
      <div className="flex">
        <DateSelector />
        <div className="flex items-end" style={{ paddingBottom: "5px" }}>
          <M.Button
            onClick={e =>
              $respondent.load(
                $survey.selected._key,
                $group.selected ? $group.selected._key : false,
                false,
                $respondent.filterDateStart,
                $respondent.filterDateEnd
              )
            }
          >
            Zoeken
          </M.Button>
        </div>
      </div>
    </div>
  );
};

export default inject("store")(observer(SurveyResultsFilter));
